import { Topics } from "../conf/Config";
import DataCenter from "../modules/DataCenter";
import WebSocketClient from "../modules/WebSocketClient";
import { JSEvent, Events } from "../utils/JSEvent";

export default class WalletViewController {
    constructor() {
        // this.topics = [
        //     Topics.marketThumb,
        // ];
        // this.onTopicMessage = this.onTopicMessage.bind(this);
        // this.subscribeTopic = this.subscribeTopic.bind(this);
    }

    init() {
        //this.subscribeTopic();
    }

    subscribeTopic() {
        // this.topics.forEach(t => {
        //     WebSocketClient.subscribe(t, this.onTopicMessage)
        // })
    }

    unsubscribeTopic() {
        // this.topics.forEach(t => {
        //     WebSocketClient.unsubscribe(t, this.onTopicMessage)
        // })
    }

    onTopicMessage(topic, message) {
        // if (topic == Topics.marketThumb) {
        //     const thumb = JSON.parse(message.body);
        //     for (const id in thumb) {
        //         DataCenter.updateThumbData(id, thumb[id]);
        //     }
        // }
    }

    destroy() {
        // this.unsubscribeTopic();
    }
}